
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'the-reset-button',
  computed: {
    disabled() {
      return this.$store.getters.isStateEmpty;
    },
  },
});
